import { useSelector} from "react-redux";
import { Avatar,Indicator, Group, Grid, createStyles, rem, } from '@mantine/core';
import React from "react";

const useStyles = createStyles((theme) => ({
  textsize: {
    fontSize: rem('16px'),
    [theme.fn.smallerThan('lg')]: {
      fontSize: rem('10px'),
    },
  },
 
}));

/**
 * Renders a list of notar users in a meeting.
 *
 * @initparticipants {Object} - state.user.meetinguser - Array of Objects containing the users in the meeting.
 * @return {JSX.Element} The rendered list of notar users in a meeting.
 */

export function NotarUserInMeeting(props:any) {
  const { classes } = useStyles();
  const initparticipants = useSelector((state: any) => state.user.meetinguser)

  // Filter Notar spezifische Daten
  const datanotar = initparticipants.filter((obj: { role: any; }) => {
  return obj.role === "notar"
  });

  const rows = (datanotar || []).map((item:any, index:any) => {
    // Make Initialen
    let a = item.lastName.substring(0,1)
    let b = item.firstName.substring(0,1)
    let initialen = a + b
    let fullname = item.lastName + " " + item.firstName
 
   let inmeetingcolor = "red"
      if (item.meetingParticipantStatus === "LeftMeeting") {
        inmeetingcolor = "red"
      }
      if (item.meetingParticipantStatus === "InMeeting") {
        inmeetingcolor = "green"
      }

   return (
    <React.Fragment key={item.id || index}>
      {props.view !== "small" &&
        <Grid key={index}>
            <Grid.Col  xs={2} md={3} lg={3} xl={2}>
              <Indicator inline size={16} offset={7} position="bottom-end" color={inmeetingcolor} withBorder>
                  <Avatar  alt={fullname} variant="filled" radius="xl" size="lg">{initialen} </Avatar>
              </Indicator>
            </Grid.Col>
            <Grid.Col xs={6} md={5} lg={5} xl={7}> 
            <Group>
            <span className={classes.textsize}>{fullname}</span>
              </Group>
            </Grid.Col>
            <Grid.Col xs={4} md={4} lg={4} xl={4}>
              <Group  spacing={5} mt={2} position="right"></Group>
            </Grid.Col>
          </Grid>
      }

      {props.view === "small" &&
        <Grid key={index}>
            <Grid.Col span={12}>
              <Group position="right" >
                <Indicator inline size={12} offset={4} position="bottom-end" color={inmeetingcolor} withBorder>
                  <Avatar color="blue" alt={fullname} variant="filled" radius="xl" size="md">{initialen} </Avatar>
                </Indicator>
              </Group>
            </Grid.Col>
        </Grid>
      }
 </React.Fragment>
    );
}); 

return (
    <>
      {rows}
    </>
  );
}